export const primengStyles = `
    .btn-xs .p-button {
      padding : 2px 7px;
      font-size: 11px;
      font-weight: 500;
    }
    .btn-xs .p-button-icon {
      font-size: 11px;
    }
    
    .btn-xs .p-togglebutton {
      padding : 5px 7px;
    }
    .btn-xs .p-togglebutton-label {
      font-size: 11px;
    }
    .btn-xs .p-togglebutton.p-togglebutton-checked {
      background: var(--p-blue-500);
      color: white;
    }
    
    .btn-xs.p-toggleswitch {
      height: 17px;
      width: 35px !important;
    }
    .btn-xs.p-toggleswitch .p-toggleswitch-handle {
      width: 13px;
      height: 13px;
      margin-top: -7px;
      top: 51%;
    }
    .btn-xs.p-toggleswitch:not(.p-disabled, .p-toggleswitch-checked) .p-toggleswitch-slider {
      background-color: #94a3b8;
    }
    
    .p-autocomplete-list .p-autocomplete-option {
      padding: 3px 10px;
    }
    
    p-autocomplete[size="small"] .p-autocomplete-clear-icon {
      width: 12px;
      height: 12px;
      margin-right: -10px;
    }
    
    .p-autocomplete .p-autocomplete-clear-icon {
      color: var(--p-red-800);
    }
    
    .p-autocomplete:has(.p-autocomplete-clear-icon) .p-autocomplete-input-sm {
      padding-inline-end: 15px !important;
      text-overflow: ellipsis;
    }
`
